import React from 'react';

import styles from './fallback-component.module.scss';

export const FallbackComponent = () => (
	<div className={styles.fallbackMessage}>Error. Failed to lazy load Rich Text Editor</div>
);
